<div class="modal-container op-picker">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">Add roles</h1>
  </div>
  <div mat-dialog-content
       class="modal-content">

    <div class="op-picker-filters">
      <span class="op-picker-hint">Members of the selected roles get access to this application.</span>
      <span class="op-picker-spacer"></span>
      <input class="datex-textbox op-picker-search"
             placeholder="Filter roles"
             (input)="filter($any($event.target).value)" />
    </div>

    <div class="op-picker-list">
      <div *ngFor="let role of list"
           class="op-picker-row"
           [class.selected]="isSelected(role)"
           (click)="onRoleToggled(role)">
        <mat-checkbox class="datex-checkbox"
                      color="primary"
                      [checked]="isSelected(role)"
                      (click)="$event.stopPropagation()"
                      (change)="onRoleToggled(role)"></mat-checkbox>
        <span class="op-picker-name">{{role.referenceName}}</span>
        <span class="op-picker-desc">{{role.description}}</span>
      </div>
      <div *ngIf="list?.length === 0"
           class="op-picker-none">No roles match, or every role is already added.</div>
    </div>

    <div *ngIf="data.copySources?.length"
         class="op-picker-copy">
      <div class="op-picker-copy-title">Copy operations from (optional)</div>
      <div class="op-picker-copy-hint">
        The new roles start with the combined operations of the roles you pick here.
      </div>
      <div class="op-picker-copy-chips">
        <button *ngFor="let source of data.copySources"
                class="op-picker-chip"
                [class.active]="isCopySourceSelected(source)"
                (click)="onCopySourceToggled(source)">
          {{source.name}} · {{source.operationCount}}
        </button>
      </div>
    </div>
  </div>
  <div mat-dialog-actions
       class="modal-toolbar commands op-picker-footer">
    <span class="op-picker-count">{{selectedCount}} selected</span>
    <button mat-button
            class="datex-button primary"
            [disabled]="selectedCount === 0"
            (click)="onSaveClicked()">Add</button>
    <button mat-button
            class="datex-button secondary"
            (click)="onCancelClicked()">
      Cancel
    </button>
  </div>
</div>
